import './stories_image.css';
